module.exports = __webpack_public_path__ + "static/turnoff-f158af423cb9e71a354f93626a17325a.png";